<template>
  <div>
    <div v-for="org in validationJournal" :key="org.ordId" class="journal-section-content">
      <h2 class="mt-8 ml-8">
        {{ org.orgName }}
      </h2>
      <JournalOrgSection
        :recommendations="prepareOrgJournal(org.orgJournal)"
      />
      <JournalSectionList
        :title="$t('views.journal.sections.spotlight')"
        :journals="[processEntityJournal(org.spotlightJournal)]"
      />
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { types } from '../../store/rootTypes';
import JournalSectionList from './JournalSectionList';
import JournalOrgSection from './JournalOrgSection';

export const prepareDocumentForDocumentCard = (doc) => ({
  documentId: doc.documentId,
  documentDetails: {
    documentType: 'document',
    ...doc,
  },
});

export default {
  name: 'JournalValidation',
  components: {
    JournalOrgSection,
    JournalSectionList,
  },
  data: () => ({
    validationJournal: [],
  }),
  methods: {
    ...mapActions({
      fetchValidationJournal: types.recommendationBasedJournals.actions.fetchValidationJournal,
    }),
    prepareOrgJournal(orgJournal) {
      return orgJournal.map(prepareDocumentForDocumentCard);
    },
    treeSections(journals, startingIndex) {
      const allJournalsMap = journals.map((journal, index) => ({
        id: journal.id,
        title: journal.title,
        focused: (startingIndex + index) === this.selectedSectionIndex,
        select: () => {
          const id = `journal-card-iterator-${startingIndex + index}`;
          const elem = document.getElementById(id);
          this.disableScrollEvent = true;
          elem.scrollIntoView();
          // To be aligned with the tree title (Journal Beta).
          elem.offsetParent.scrollTop -= 10;
          // Wait the animation that may start an unwanted scroll event.
          setTimeout(() => { this.disableScrollEvent = false; }, 100);
          this.selectedSectionIndex = startingIndex + index;
        },
      }));
      return allJournalsMap;
    },
    processEntityJournal(entityJournal) {
      if (!entityJournal) return undefined;

      const { entityType, id, editable } = entityJournal.journal;
      const title = this.getJournalTitle(entityJournal);
      const type = this.getJournalType(entityJournal);
      const recommendations = entityJournal.recommendations.map(rec => this.processRecommendation(rec));

      return {
        id,
        title,
        type,
        entityType,
        recommendations,
        editable,
      };
    },
    processRecommendation(data) {
      const { documentData, recommendation } = data;
      if (documentData === undefined) {
        return { documentData: {} };
      }
      const basicInformation = {
        ...documentData,
        recommendation,
      };

      if (documentData.documentType === 'document') {
        return prepareDocumentForDocumentCard(basicInformation);
      }

      return basicInformation;
    },
    getJournalTitle(entityJournal) {
      return entityJournal.journal.title; // TODO
    },
    getJournalType(entityJournal) {
      if (entityJournal.journal.origin && entityJournal.journal.origin.type) {
        return entityJournal.journal.origin.type;
      }
      return 'system';
    },
  },
  async created() {
    this.validationJournal = await this.fetchValidationJournal();
  },
};
</script>
